export const deviceChangeSubscription = deviceGroupId => /* GraphQL */ `
  subscription DeviceChangedEvent {
    notifyDeviceEvent(input: { deviceGroupId: ${deviceGroupId} }) {
      type
      companyId
      device {
        id
        status
        lastAccess
        lastSeen
        firstSeen
        lastLoggedInUser {
          userName
        }
        premium
        status
        zeroTrustEnabled
        deviceName
        labels
        hostName
        osName
        osVersion
        clientVersion
        clientType
        ipAddresses
        macAddresses
        biosVersion
        biosSerialNumber
        shellUrl
        companyId
        inSession
        locked
        platform
        processor
        systemFolder
        systemManufacturer
        systemModel
        timeZone
        timeZoneOffset
        tlsInfo
        totalPhysicalMemory
        userLocale
        windowsFolder
        verified
        deviceGroupId
        foreignSystemId
        foreignSystemKind
        av {
          rtpAvailable
          rtpStatus
          detectedAVSignature
          detectedAVName
          lastScanOn
          updatedOn
          definitionNumber
          avHealthStatus
          avInstalled
          lastDiscoveryOn
          lastReportOn
          scanStatus
          firewallStatus
        }
      }
      previousDevice {
        id
        lastAccess
        lastSeen
        firstSeen
        lastLoggedInUser {
          userName
        }
        status
        premium
        zeroTrustEnabled
        deviceName
        labels
        hostName
        osName
        osVersion
        clientVersion
        clientType
        ipAddresses
        macAddresses
        biosVersion
        companyId
        inSession
        locked
        platform
        processor
        systemFolder
        systemManufacturer
        systemModel
        timeZone
        timeZoneOffset
        tlsInfo
        totalPhysicalMemory
        userLocale
        windowsFolder
        verified
        av {
          rtpAvailable
          rtpStatus
          detectedAVSignature
          detectedAVName
          lastScanOn
          updatedOn
          definitionNumber
          avHealthStatus
          avInstalled
          lastDiscoveryOn
          lastReportOn
          scanStatus
          firewallStatus
        }
        deviceGroupId
        foreignSystemId
        foreignSystemKind
      }
    }
  }
`;
